const formatDate = (value) => { 
    const date = typeof value === "string" ? new Date(value) : value;

    if (date instanceof Date && !isNaN(date)) {
      return date.toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",

        hour:"2-digit",
        minute:"2-digit"
      });
    } else { 
      return "Tarih Ayarlanamadı";
    }
  };

export default formatDate;

